module.exports = __webpack_public_path__ + "static/media/sumar.f73ace4b.svg";